import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import SystemMessage from '../../../SystemMessage/SystemMessage';

const EndPersonalizationWarning = ({
  isSubmitting,
  isUpdatingProspect,
  saveError,
  closeModal,
}) => (
  <div data-testid="personalization-step:end-warning">

    <div className="modal__section">
      <div className="modal__title modal__title--short modal__subsection">
        Stop Personalization?
      </div>
      <div className="modal__subsection modal__description modal__description--short">
        Are you sure you want to stop the personalization session with this prospect?
      </div>

      {/* The save failed, so the session is still running and its cookies are
      the only copy. Without this the spinner just stops and "Yes" looks like
      it did nothing. role="alert" so a screen reader announces it too. */}
      {saveError && (
        <div className="modal__subsection" role="alert">
          <SystemMessage
            status="error"
            message={saveError}
            testId="personalization-end-error"
          />
        </div>
      )}
    </div>

    <div className="modal__section modal__btns modal__btns--inline">
      <button
        disabled={isSubmitting || isUpdatingProspect}
        type="submit"
        className={classNames('modal__btn modal__btn--secondary', {
          'modal__btn--working': isSubmitting,
        })}
        data-testid="personalization-confirm-end"
      >
        { isSubmitting || isUpdatingProspect ? 'Updating Prospect . . .' : 'Yes'}
      </button>

      { !isUpdatingProspect && (
        <button
          type="button"
          className="modal__textBtn"
          onClick={() => closeModal()}
        >
          Or No, Continue Session
        </button>
      )}
    </div>

  </div>
);

EndPersonalizationWarning.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  isUpdatingProspect: PropTypes.bool.isRequired,
  saveError: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
};

EndPersonalizationWarning.defaultProps = {
  saveError: null,
};

export default EndPersonalizationWarning;
